import React from "react";
import DepartmentForm from "./DepartmentForm";
import PropTypes from "prop-types";

import { IntlProvider } from "react-intl";
import { translations } from "../util/i18n";
import ModalLauncher from "../util/ModalLauncher";

const AddDepartmentModal = (props) => {
  const modalContent = () => {
    return <DepartmentForm url={props.url} method="POST"/>;
  };

  return (
    <IntlProvider
      locale={window._FLAIM_LOCALE}
      key={window._FLAIM_LOCALE}
      messages={translations[window._FLAIM_LOCALE]}
    >
      <ModalLauncher
        buttonId="create-department"
        buttonText="departments.create-department"
        content={modalContent()}
        title="departments.create-department"
      />
    </IntlProvider>
  );
};

AddDepartmentModal.propTypes = {
  url: PropTypes.string.isRequired,
};

export default AddDepartmentModal;
